import { Box } from '@mui/material';
import { TranscriptionEditModeAction } from '../actions/TranscriptionEditModeAction';
import { TranscriptionSyncAction } from '../actions/TranscriptionSyncAction';
import { TranscriptionWordEfficiencyAction } from '../actions/TranscriptionWordEfficiencyAction';
import { TranscriptionSearch } from '../search/TranscriptionSearch';

type TranscriptionViewV2ToolbarProps = {
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
};

/** Toolbar row: transcript search on the left; follow-playback sync and word-efficiency toggles on the right. */
export function TranscriptionToolbar({
  searchQuery,
  onSearchQueryChange,
}: TranscriptionViewV2ToolbarProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        gap: 1,
        mb: 1,
      }}
    >
      <TranscriptionSearch query={searchQuery} onQueryChange={onSearchQueryChange} />
      <Box sx={{ display: 'flex', flexShrink: 0, gap: 0.5 }}>
        <TranscriptionEditModeAction />
        <TranscriptionSyncAction />
        <TranscriptionWordEfficiencyAction />
      </Box>
    </Box>
  );
}
